export default __webpack_public_path__ + "static/media/awards.143781fa.webp";